export default "__VITE_ASSET__BzNpKHz5__"